import DownIcon from '@assets/svg/table-down.svg';
import UpIcon from '@assets/svg/table-up.svg';
import { ITooltip } from '@components/Tooltip';
import { getTagTip } from '@pages/Products/components/ListProducts/ListProducts.utils';
import { ColumnContainer, ColumnName, Direction } from './Updates.styles';

interface IColumnTitle extends React.HTMLAttributes<HTMLDivElement> {
  label: string;
  direction?: 'up' | 'down';
  onClick?: () => void;
}
const enabledTooltip = ['Related Tags'];
function getTooltipText(label: string) {
  if (label === 'Related Tags') return getTagTip(true);
  return '';
}
export const ColumnTitle = ({ label, direction, ...rest }: IColumnTitle) => {
  return (
    <ColumnContainer
      {...rest}
      data-tip={getTooltipText(label)}
      data-for={`heading-info-${label}`}
    >
      <ColumnName>{label}</ColumnName>
      {!!direction && (
        <Direction>
          <img src={direction === 'up' ? UpIcon : DownIcon} alt="direction" />
        </Direction>
      )}
      <ITooltip
        id={`heading-info-${label}`}
        effect="solid"
        place="top"
        disable={!enabledTooltip.includes(label)}
      />
    </ColumnContainer>
  );
};
